import { TableData } from '../table-data';
export class AsIsTableDataTransform {
	public static readonly instance = new AsIsTableDataTransform();

	public transform(data: TableData): TableData {
		return data;
	}
}
